import React from 'react'

interface ArrowBigDownProps {
  size?: number
  color?: string
}

export const ArrowBigDown: React.FC<ArrowBigDownProps> = ({
  size = 24,
  color = '#000',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3v18m6-6l-6 6-6-6"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
